import StoreDownloadButton from "./StoreDownloadButton";

const DownloadCard = ({ title, TitleIcon, TitleIconSize=14, storeLabel, storeName, href, ButtonIcon, iconSize = 24, qrSrc }) => {
    return (
        <div className="flex flex-col items-center rounded-2xl md:bg-secondaryExtraLight md:p-8">
            <h3 className="mb-6 hidden items-center gap-2 text-lg font-bold text-secondary md:flex">
                {TitleIcon && <TitleIcon size={TitleIconSize} />}
                {title}
            </h3>
            <div className="mb-6 hidden aspect-square w-full max-w-40 items-center justify-center rounded-xl bg-white p-4 md:flex">
                <img
                    src={qrSrc}
                    alt={`QR code de téléchargement ${storeName}`}
                    className="h-full w-full object-contain"
                />
            </div>
            <StoreDownloadButton
                href={href}
                Icon={ButtonIcon}
                iconSize={iconSize}
                storeLabel={storeLabel}
                storeName={storeName}
                ariaLabel={`Télécharger PretUp sur ${storeName}`}
                className="w-full max-w-56 justify-center"
            />
        </div>
    );
};

export default DownloadCard;
